/**
 * xike 客户点位监控
 */
import { customerCreate } from '@/utils/cartq';
import { executeWhenReady } from '@/utils/execute';

export const chatMonitor = () => {
  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node: any) => {
          if (node.tagName === 'IFRAME') {
            node.onload = function () {
              // 可以在这里对 iframe 执行监控操作
              if (node.src.includes('https://customer.erp.chicv.com/css/app')) {
                // console.log('页面增加iframe', node.src);
                const [url, params] = node.src.split('/#/');
                const searchParams = new URLSearchParams(params);
                const email = searchParams.get('form_email');

                customerCreate({ email, phone: '' });
              }
            };
          }
        });
      }
    }
  });

  executeWhenReady(() => {
    observer.observe(document.body, { childList: true, subtree: true });
  });
};
